module.exports = __webpack_public_path__ + "img/discoverS.6d00da0c.png";